let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ftS0S")).then(() => parcelRequire('3XMWt'));